import {isFeatureEnabled} from 'feature-flags';

import {CountryAlpha3CodeEnum} from '@dms/api/shared';
import {featureFlags} from '@dms/feature-flags';

import {useTenant} from './useTenant';

const QUALITY_SEAL_COUNTRIES: CountryAlpha3CodeEnum[] = ['BEL', 'CZE', 'DEU', 'POL'];

export const useIsQualitySealVisible = () => {
  const {tenant, isTenantCountryRestricted} = useTenant();

  return (
    isFeatureEnabled(featureFlags.QUALITY_SEAL) &&
    tenant?.country !== undefined &&
    isTenantCountryRestricted(QUALITY_SEAL_COUNTRIES)
  );
};
